import { Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useFeedbackDrawerContext } from './feedback.drawer.ctx';

export const FeedbackDrawerFile = observer(() => {
	const { selectedItem, downloadFile } = useFeedbackDrawerContext();
	if (!selectedItem?.fileId) return null;

	return (
		<Button fullWidth variant="outlined" onClick={downloadFile}>
			Download file
		</Button>
	);
});
